'use client';

import type { HeaderSectionProps } from '@/containers/layouts/core';

import React from 'react';

import { Logo } from '@/components/logo';
import { Box, Container } from '@/components/ui';

import { SimpleFooter } from '@/containers/layouts/components/footer';
import { SignInButton } from '@/containers/layouts/components/sign-in-button';
import { MainSection, HeaderSection, LayoutSection } from '@/containers/layouts/core';

interface SimpleLayoutProps {
  children: React.ReactNode;
  slotProps?: {
    content?: {
      compact?: boolean;
    };
  };
}

export const SimpleLayout: React.FC<SimpleLayoutProps> = ({ children, slotProps = {} }) => {
  const { content = {} } = slotProps;
  const { compact = false } = content;

  const renderHeader = () => {
    const headerSlots: HeaderSectionProps['slots'] = {
      leftArea: <Logo className="w-[109px] h-[43px] lg:w-[170px] lg:h-[67px]" />,
      rightArea: (
        <Box className="flex items-center gap-0">
          <SignInButton />
        </Box>
      ),
    };

    return <HeaderSection className="border border-gray-200" slots={{ ...headerSlots }} />;
  };

  const renderFooter = () => <SimpleFooter />;

  const renderMain = () => (
    <MainSection className="justify-center items-center py-16">
      <Container maxWidth={compact ? 'md' : 'l'} className={compact ? 'text-center' : ''}>
        {children}
      </Container>
    </MainSection>
  );

  return (
    <LayoutSection
      /** **************************************
       * @Header
       *************************************** */
      headerSection={renderHeader()}
      /** **************************************
       * @Footer
       *************************************** */
      footerSection={renderFooter()}
    >
      {renderMain()}
    </LayoutSection>
  );
};

export default SimpleLayout;
